import * as React from "react";
import {Flag, Label, Segment, Table} from "semantic-ui-react";
import {OptionDto, OptionTextDto} from "../../../services/Client";
import PromtFormatter from "src/components/Table/components/reactQuill/PromtFormatter";

interface IUDAErrorResultStepProps {
    result: {[key: number]: string};
    items: OptionDto[];
    /** Translation */
    t: reactI18Next.TranslationFunction;
}

export const UDAErrorResultStep = (props: IUDAErrorResultStepProps) => (
    <>
        <p style={{marginBottom: '10px', color: 'red'}}><b>{Object.keys(props.result).length + ' '}</b> {props.t("UPDATE_DRF_ASGN:RESULT_ERROR")}</p>
        <Table
            celled={true}
            structured={true}
            className={"text-align--center"}
        >
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>{props.t("UPDATE_DRF_ASGN:OPTION_IDENTIFIER")}</Table.HeaderCell>
                    <Table.HeaderCell>{props.t("UPDATE_DRF_ASGN:SHORTTEXT")}</Table.HeaderCell>
                    <Table.HeaderCell>{props.t("UPDATE_DRF_ASGN:ERROR_MSG")}</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {Object.keys(props.result).map((key: string, index: number) => {
                    const dto = props.items.find((a) => a.objectId.toString() === key);

                    return (
                        <Table.Row key={'row-' + index}>
                            <Table.Cell>
                                <Label size={'large'} className={'whitespace--nowrap'}>
                                    {
                                        // @ts-ignore
                                        dto.optionBasic.optionCode
                                    }
                                    <Label.Detail>
                                        {
                                            // @ts-ignore
                                            dto.optionBasic.optionType
                                        }
                                    </Label.Detail>
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Segment.Group horizontal={true}>
                                    {
                                        // @ts-ignore
                                        dto.texts.sort((a, b) =>
                                            (a.language && b.language && a.language.code && b.language.code && a.language.code > b.language.code) ? 1 : -1)
                                            .map((txt: OptionTextDto, idx: number) =>
                                                <Segment
                                                    key={"txt-" + idx}
                                                    className={'update-draft-asgn-text-segment'}
                                                >
                                                    <Flag
                                                        name={txt.language && txt.language.code === "de" ? "de" : "gb"}
                                                        className={'update-draft-asgn-text-flag'}
                                                    />
                                                    {txt.shorttext || ""}
                                                </Segment>
                                            )}
                                </Segment.Group>
                            </Table.Cell>
                            <Table.Cell>
                                {props.result[key]}
                            </Table.Cell>
                        </Table.Row>
                    );
                })}
            </Table.Body>
        </Table>
    </>
);



// WEBPACK FOOTER //
// ./src/views/OptionsView/updateDraftAssignments/UDAErrorResultStep.tsx